module.exports = __webpack_public_path__ + "static/media/user.3444a1e8.svg";